/* eslint-disable max-lines */
import { InterceptorClient } from "../../interceptor/interceptorClient";
import { withLatestLocation } from "../../utils/common";
import { fetchContentFromCMSOnClient } from "../common";
import {
  GET_COUPON_LIST,
  GET_OCCASIONS_AND_TEMPLATE_MSGS,
  GET_CARD_MESSAGE_DETAILS,
  SET_CARD_MESSAGE_DETAILS,
  APPLY_COUPON,
  REMOVE_COUPON,
  SET_ITEM_ATTRIBUTE_FOR_ORDER_ITEM,
  GET_CURRENT_SENDER_DETAILS,
  GET_CART_AMOUNT_SUMMARY_DETAILS,
  GET_SEARCH_SUGGESTION_DETAILS,
  GET_SALUTATION_DETAILS,
  GET_SPECIAL_COUNTRIES,
  SET_ITEM_ATTRIBUTE_FOR_ADDRESS_FORM,
  DELETE_ADDRESS_FORM_ITEM,
  GET_DONATION_STATUS,
  GET_DONATION_AMOUNT,
  ADD_DONATION_AMOUNT,
  REMOVE_DONATION_AMOUNT,
  GET_CARRY_BAG_AMOUNT,
  ADD_CARRY_BAG_AMOUNT,
  REMOVE_CARRY_BAG_AMOUNT,
  SET_UPDATE_CART_FROM_DA_PAGE,
  CHECK_SERVICE_AVAILABLE_FOR_PINCODE,
  GET_PERSONALIZATION_DETAILS,
  RESET_DELIVERY,
  VALIDATE_ADDRESS,
  GET_PRODUCT_ITEM_QUANTITY,
  PERSIST_ANALYTICS_SESSION_ID,
  SEND_MOBILE_OTP,
  VALIDATE_MOBILE_OTP,
} from "./constants";
const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;

/**
 * API for fetching complete cart details on delivery address page.
 *
 * @returns {Promise<Object>} - A promise that resolves to the complete cart details data.
 */
export const getCouponList = async () => {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).get(GET_COUPON_LIST(), false);
    return response;
  } catch (error) {
    console.log(error);
  }
};

/**
 * Fetches the details of the current sender.
 * This function makes an API call to the endpoint defined by `GET_CURRENT_SENDER_DETAILS`
 * and returns the response containing the sender's details. If an error occurs during the
 * API request, it logs the error to the console.
 * @async
 * @returns {Promise<Object|undefined>} A promise that resolves to the response object containing the sender's details.
 * @throws {Error} Logs any error that occurs during the API request to the console.
 */
export const getSenderDetails = async () => {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).get(GET_CURRENT_SENDER_DETAILS(), false);
    return response;
  } catch (error) {
    console.log(error);
  }
};
/**
 * API for fetch the sender details on delivery page.
 * @returns {Promise<Object>} - A promise that resolves to the sender's details data.
 * This object will contain the complete cart details related to the sender, such as customerDetails,
 * errorMsg, isSuccess,sessionId etc.
 * @param {string} value- specifies the search text.
 * @throws {Error} - Logs an error to the console if the request fails.
 */
export const fetchCitySearchSuggestions = async (value) => {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).get(GET_SEARCH_SUGGESTION_DETAILS(value), false);
    return response;
  } catch (error) {
    console.log(error);
  }
};

/**
 * API for fetch the sender details on delivery page.
 * @returns {Promise<Object>} - A promise that resolves to the sender's details data.
 * This object will contain the complete cart details related to the sender, such as customerDetails,
 * errorMsg, isSuccess,sessionId etc.
 * @throws {Error} - Logs an error to the console if the request fails.
 */
export const fetchSalutationApi = async () => {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).get(GET_SALUTATION_DETAILS(), false);
    return response;
  } catch (error) {
    console.log(error);
  }
};
/**
 * API for fetch the sender details on delivery page.
 * @returns {Promise<Object>} - A promise that resolves to the sender's details data.
 * This object will contain the complete cart details related to the sender, such as customerDetails,
 * errorMsg, isSuccess,sessionId etc.
 * @throws {Error} - Logs an error to the console if the request fails.
 */
export const fetchSpecialCountryApi = async () => {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).get(GET_SPECIAL_COUNTRIES(), false);
    return response;
  } catch (error) {
    console.log(error);
  }
};
/**
 *
 * @param {*} params
 * @returns
 */
export const setOrderItemAttribute = async (params) => {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).post(
      params,
      SET_ITEM_ATTRIBUTE_FOR_ORDER_ITEM(),
      false,
      { "x-api-version": "v1.4" },
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
/**
 *
 * @param {*} params
 * @returns
 */
export const setAddressFormForItem = async (params) => {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).post(
      params,
      SET_ITEM_ATTRIBUTE_FOR_ADDRESS_FORM(),
      false,
      { "x-api-version": "v1.4" },
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
/**
 *
 * @param {*} params
 * @returns
 */
export const setUpdateCartFromDaPage = async (params) => {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).post(
      params,
      SET_UPDATE_CART_FROM_DA_PAGE(),
      false,
      { "x-api-version": "v1.4" },
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
/**
 *
 * @param {*} params
 * @returns
 */
export const deleteAddressFormForItem = async (params) => {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).get(DELETE_ADDRESS_FORM_ITEM(params), false);
    return response;
  } catch (error) {
    console.log(error);
  }
};

/**
 * API for setting the user given card details for Free Message Card
 *
 *  @returns {Promise<Object>} - A promise that resolves to the JSON response containing list of occasions.
 */
export const applyCoupon = async (params) => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).post(params, `${APPLY_COUPON()}`, false);
  } catch (error) {
    console.log(error);
  }
};
/**
 * API for setting the user given card details for Free Message Card
 *
 *  @returns {Promise<Object>} - A promise that resolves to the JSON response containing list of occasions.
 */
export const removeAppliedCoupon = async (params) => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).post(params, `${REMOVE_COUPON()}`, false);
  } catch (error) {
    console.log(error);
  }
};

/**
 * API for fetching list of occasions for Free Message Card
 *
 *  @returns {Promise<Object>} - A promise that resolves to the JSON response containing list of occasions.
 */
export const getOccasionsAndTemplate = async () => {
  try {
    return await InterceptorClient.getGatewayInstance().get(GET_OCCASIONS_AND_TEMPLATE_MSGS(), false);
  } catch (error) {
    console.log(error);
  }
};
/**
 * API for fetching list of occasions for Free Message Card
 *
 *  @returns {Promise<Object>} - A promise that resolves to the JSON response containing list of occasions.
 */
export const getCardMessageDetails = async (cartItemIndex) => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(GET_CARD_MESSAGE_DETAILS(cartItemIndex), false);
  } catch (error) {
    console.log(error);
  }
};
/**
 * API for fetching list of occasions for Free Message Card
 *
 *  @returns {Promise<Object>} - A promise that resolves to the JSON response containing list of occasions.
 */
export const setCardMessageDetails = async (params) => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).post(params, `${SET_CARD_MESSAGE_DETAILS()}`, false, {
      "x-api-version": "v1.4",
    });
  } catch (error) {
    console.log(error);
  }
};
/**
 * API for fetching complete cart amount summary
 *
 *  @returns {Promise<Object>} - A promise that resolves to the JSON response containing list of occasions.
 */
export const getCartAmountSummary = async () => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(GET_CART_AMOUNT_SUMMARY_DETAILS(), false, null, {
      "x-api-version": "v1.4",
    });
  } catch (error) {
    console.log(error);
  }
};
/**
 * API for adding donation amount to cart amount summary.
 *
 *  @returns {Promise<Object>} - A promise that resolves to the JSON response containing list of occasions.
 */
export const addDonationAmount = async (donationAmount) => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(ADD_DONATION_AMOUNT(donationAmount), false);
  } catch (error) {
    console.log(error);
  }
};
/**
 * API for adding donation amount to cart amount summary.
 *
 *  @returns {Promise<Object>} - A promise that resolves to the JSON response containing list of occasions.
 */
export const removeDonationAmount = async (donationAmount) => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(REMOVE_DONATION_AMOUNT(donationAmount), false);
  } catch (error) {
    console.log(error);
  }
};
/**
 * API for fetching donation status
 *
 *  @returns {Promise<Object>} - A promise that resolves to the JSON response containing list of occasions.
 */
export const getDonationStatus = async () => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(GET_DONATION_STATUS(), false);
  } catch (error) {
    console.log(error);
  }
};
/**
 * API for fetching donation amount
 *
 *  @returns {Promise<Object>} - A promise that resolves to the JSON response containing list of occasions.
 */
export const getDonationAmount = async () => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(GET_DONATION_AMOUNT(), false);
  } catch (error) {
    console.log(error);
  }
};

/**
 * API for fetching carry-bag status
 *
 * @returns {String}
 */
export const getCarryBagInfo = async () => {
  try {
    return fetchContentFromCMSOnClient("global/static/web/carry-bag-info");
  } catch (error) {
    console.log(error, "CMS API error");
  }
};
/**
 * API for fetching carry-bag status
 *
 * @returns {String}
 */
export const getCryDonationInfo = async () => {
  try {
    return fetchContentFromCMSOnClient("global/static/web/cry-donation-info");
  } catch (error) {
    console.log(error, "CMS API error");
  }
};

/**
 * API for fetching CARRY BAG amount
 *
 *  @returns {Promise<Object>} - A promise that resolves to the JSON response containing list of occasions.
 */
export const getCarryBagAmount = async () => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(GET_CARRY_BAG_AMOUNT(), false);
  } catch (error) {
    console.log(error);
  }
};

/**
 * API for adding carry bag amount
 *
 *  @returns {Promise<Object>} - A promise that resolves to the JSON response containing list of occasions.
 */
export const addCarryBagAmount = async (carryBagAmount) => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(ADD_CARRY_BAG_AMOUNT(carryBagAmount), false);
  } catch (error) {
    console.log(error);
  }
};

/**
 * API for adding carry bag amount
 *
 *  @returns {Promise<Object>} - A promise that resolves to the JSON response containing list of occasions.
 */
export const removeCarryBagAmount = async (carryBagAmount) => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(REMOVE_CARRY_BAG_AMOUNT(carryBagAmount), false);
  } catch (error) {
    console.log(error);
  }
};

/**
 * API for fetching personalization details.
 *
 * @param {string} orderItemSeqId - The order item sequence id.
 * @returns {Promise<Object>} - A promise that resolves to the JSON response containing personalization details.
 */
export const viewPersonalizationDetailsForCart = async (orderItemSeqId) => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(GET_PERSONALIZATION_DETAILS(orderItemSeqId), false);
  } catch (error) {
    console.log(error);
  }
};

/**
 * API for checking service availability for pincode.
 *
 * @param {Object} payload - The payload for the API request.
 * @returns {Promise<Object>} - A promise that resolves to the JSON response containing the service availability details.
 */
export const checkServiceAvailabilityForPincode = async (payload) => {
  try {
    return await InterceptorClient.getGatewayInstance().post(
      withLatestLocation(payload),
      CHECK_SERVICE_AVAILABLE_FOR_PINCODE(),
      false,
      {
        "x-api-version": "v1.4",
      },
    );
  } catch (error) {
    console.log(error);
  }
};

/**
 * Validates the map form address: resolves the location's pincode and checks an entered pincode against it.
 * Errors resolve to null so the form is never blocked by a failed call.
 *
 * @param {Object} payload - { locality, address, lat, long, prefilledPincode?, actualPincode?, accuracy }.
 * @returns {Promise<Object|null>} - { pincode, city, lat, long, isSaveAddressDisabled?, suggestionText? } or null.
 */
export const validateAddress = async (payload) => {
  try {
    const response = await InterceptorClient.getGatewayInstance().post(payload, VALIDATE_ADDRESS(), false);
    // The HTTP client resolves failures as { status, data }; only a successful body is used.
    if (response?.status) return null;
    /**
     * @param {*} value
     * @returns {boolean} true for a plain object.
     */
    const isPlainObject = (value) => Boolean(value) && typeof value === "object" && !Array.isArray(value);
    // Body is either { data: { pincode, ... } } or the fields at the top level ({ pincode, ..., suggestionText }).
    if (isPlainObject(response?.data)) return response.data;
    const hasResultFields = ["pincode", "suggestionText", "isSaveAddressDisabled"].some(
      (key) => key in (response || {}),
    );
    return isPlainObject(response) && hasResultFields ? response : null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

/**
 * API for resetting deliveries.
 *
 * @returns {Promise<Object>} - A promise that resolves to the JSON response containing the reset delivery details.
 */
export const resetDelivery = async () => {
  try {
    return await InterceptorClient.getGatewayInstance().post(null, RESET_DELIVERY(), false, {
      "x-api-version": "v1.4",
    });
  } catch (error) {
    console.log(error);
  }
};

/**
 * API for fetching product item quantity.
 *
 * @returns {Promise<Object>} - A promise that resolves to the JSON response containing the product item quantity.
 */
export const getProductItemQuantity = async () => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(GET_PRODUCT_ITEM_QUANTITY(), false);
  } catch (error) {
    console.log(error);
  }
};

/**
 * API for sending OTP on the sender's mobile number.
 *
 * @param {URLSearchParams} params - The form encoded payload holding mobile number, country code and device type.
 * @returns {Promise<Object>} - A promise that resolves to the JSON response of the send mobile OTP request.
 */
export const sendMobileOtp = async (params) => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).post(params, SEND_MOBILE_OTP(), false, {
      "Content-Type": "application/x-www-form-urlencoded",
    });
  } catch (error) {
    console.log(error);
  }
};

/**
 * API for validating the OTP sent on the sender's mobile number.
 *
 * @param {URLSearchParams} params - The form encoded payload holding mobile number, country code and OTP.
 * @returns {Promise<Object>} - A promise that resolves to the JSON response of the validate mobile OTP request.
 */
export const verifyMobileOtp = async (params) => {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).post(params, VALIDATE_MOBILE_OTP(), false, {
      "Content-Type": "application/x-www-form-urlencoded",
    });
  } catch (error) {
    console.log(error);
  }
};

/**
 * set user Clevertap session IDs
 *
 * @param {string} cleverTapUserID Clevertap user ID
 * @param {string} analyticsSessionID Analytics session ID
 * @returns {Promise<Object>} - A promise that resolves to the JSON response containing the user Clevertap session IDs.
 */
export const setUserClevertapSessionIDs = async (cleverTapUserID, analyticsSessionID) => {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).post(
      { ctId: cleverTapUserID, analyticsSessionId: analyticsSessionID },
      PERSIST_ANALYTICS_SESSION_ID(),
      false,
      { "x-api-version": "v1.4", "content-type": "application/x-www-form-urlencoded" },
    );
    return response;
  } catch (err) {
    console.log(err);
  }
};
